import React, {Component} from 'react';
import axios from 'axios';
import $ from 'jquery';
import Header from "./Header";
import SideBar from "./SideBar";
import Chart from 'chart.js/auto';
import Data from "./Data";
import {CircularProgress} from "@material-ui/core";

class Panel extends Component {

    constructor(props) {
        super(props);
        this.state = {
            day: 7,
            allpay: 0,
            alluser: 0,
            allview1: 0,
            allview2: 0,
            allview3: 0
        };
        this.myChart = null;
        this.viewsChart = null;
        this.usersChart = null;
        this.incomeChart = null;


    }

    componentDidMount() {
        $('#progressTop').addClass('invisible');
        $('#no_item').addClass('invisible');

        // $(document).on('load', '#table-1', function(e) {
        //     $(this).floatThead({
        //         responsiveContainer: function($table){
        //             return $table.closest(".table-responsive");
        //         }
        //     });
        //
        // });

        let views = document.getElementById('views');
        this.viewsChart = new Chart(views , {
            type: 'line',
            data: {
                labels: ['7 روز پیش','6 روز پیش','5 روز پیش','4 روز پیش','3 روز پیش','2 روز پیش','دیروز','امروز'],
                datasets:[{
                    data: [1 ,2 , 1 , 2 ,1 , 2 , 1,2],
                    backgroundColor: '#fff',
                    borderColor : '#fff',
                    borderWidth : 2 ,
                    tension: 0.4,
                    pointBackgroundColor: '#fff'
                }]
            },
            options: {
                animations:{
                    tension: {
                        duration: 1000,
                        easing: 'linear',
                        from: 0.4,
                        to: 0.9,
                        loop: true
                    }
                },
                responsive: true,
                maintainAspectRatio: false,
                interaction: {
                    mode: 'index',
                    intersect: false,
                    font: {
                        size: 14,
                        family: "'IRANSans',IRANSansWeb"
                    }
                },
                layout: {
                    padding: {
                        left: 3,
                        right: 3
                    }
                },
                scales: {
                    y: {
                        display:false
                    },
                    x: {
                        display:false
                    }
                },
                plugins: {
                    legend: {
                        display: false
                    },
                    title: {
                        color: '#fff',
                        display: true,
                        font: {
                            size: 12,
                            family: "'IRANSans',IRANSansWeb"
                        },
                        text:'نمودار بازدید سایت در هفته اخیر'
                    }
                }
            }
        });

        let users = document.getElementById('users');
        this.usersChart = new Chart(users , {
            type: 'line',
            data: {
                labels: ['7 روز پیش','6 روز پیش','5 روز پیش','4 روز پیش','3 روز پیش','2 روز پیش','دیروز','امروز'],
                datasets:[{
                    data: [1 ,2 , 1 , 2 ,1 , 2 , 1,2],
                    backgroundColor: '#fff',
                    borderColor : '#fff',
                    borderWidth : 2 ,
                    tension: 0.4,
                    pointBackgroundColor: '#fff'
                }]
            },
            options: {
                animations:{
                    tension: {
                        duration: 1000,
                        easing: 'linear',
                        from: 0.4,
                        to: 0.9,
                        loop: true
                    }
                },
                responsive: true,
                maintainAspectRatio: false,
                interaction: {
                    mode: 'index',
                    intersect: false,
                    font: {
                        size: 14,
                        family: "'IRANSans',IRANSansWeb"
                    }
                },
                layout: {
                    padding: {
                        left: 3,
                        right: 3
                    }
                },
                scales: {
                    y: {
                        display:false
                    },
                    x: {
                        display:false
                    }
                },
                plugins: {
                    legend: {
                        display: false
                    },
                    title: {
                        color: '#fff',
                        display: true,
                        font: {
                            size: 12,
                            family: "'IRANSans',IRANSansWeb"
                        },
                        text:'نمودار کاربران جدید در هفته اخیر'
                    }
                }
            }
        });
        let income = document.getElementById('income');
        this.incomeChart = new Chart(income , {
            type: 'line',
            data: {
                labels: ['7 روز پیش','6 روز پیش','5 روز پیش','4 روز پیش','3 روز پیش','2 روز پیش','دیروز','امروز'],
                datasets:[{
                    data: [1 ,2 , 1 , 2 ,1 , 2 , 1,2],
                    backgroundColor: '#fff',
                    borderColor : '#fff',
                    borderWidth : 2 ,
                    tension: 0.4,
                    pointBackgroundColor: '#fff'
                }]
            },
            options: {
                animations:{
                    tension: {
                        duration: 1000,
                        easing: 'linear',
                        from: 0.4,
                        to: 0.9,
                        loop: true
                    }
                },
                responsive: true,
                maintainAspectRatio: false,
                interaction: {
                    mode: 'index',
                    intersect: false,
                    font: {
                        size: 14,
                        family: "'IRANSans',IRANSansWeb"
                    }
                },
                layout: {
                    padding: {
                        left: 3,
                        right: 3
                    }
                },
                scales: {
                    y: {
                        display:false
                    },
                    x: {
                        display:false
                    }
                },
                plugins: {
                    legend: {
                        display: false
                    },
                    title: {
                        color: '#fff',
                        display: true,
                        font: {
                            size: 12,
                            family: "'IRANSans',IRANSansWeb"
                        },
                        text:'نمودار درآمد سایت در هفته اخیر'
                    }
                }
            }
        });

        let d = 7;
        let data1 = new FormData();
        data1.append('token', '');
        data1.append('day', d);
        axios.post(Data.server+`getSiteInfo.php`,data1)
            .then(response=> {

                if (response.data.hasOwnProperty('allpay')){
                    let texts = [];
                    let values1 = [];
                    let values2 = [];
                    for (let i = d;i>=0;i--){
                        if (i===0){
                            texts.push('امروز');
                        }else if(i===1){
                            texts.push('دیروز');
                        }else {
                            texts.push(i+' روز پیش');
                        }
                        let v1 = parseInt(response.data['newuser'+i]);
                        let v2 = parseInt(response.data['newpay'+i]);
                        values1.push(v1);
                        values2.push(v2);
                    }

                    this.setState({
                        allpay:parseInt(response.data['allpay']),
                        alluser:parseInt(response.data['alluser']),
                    });


                    this.incomeChart.data.labels = texts;
                    this.usersChart.data.labels = texts;
                    this.incomeChart.data.datasets[0].data = values2;
                    this.usersChart.data.datasets[0].data = values1;
                    this.incomeChart.options.animations = {

                    };
                    this.usersChart.options.animations = {

                    };
                    this.incomeChart.update();
                    this.usersChart.update();

                }
            })
            .catch(err=>{
                console.log(err);
            });

        $('.dropdown-toggle').dropdown();
        this.loadChart(this.state.day);

    }

    loadChart(day){
        this.setState({
            day: day
        })
        let data1 = new FormData();
        data1.append('token', '');
        data1.append('day', day);
        axios.post(Data.server+`getView.php`,data1)
            .then(response=> {

                if (response.data.hasOwnProperty('day01')){
                    let texts = [];
                    let values1 = [];
                    let values2 = [];
                    let values3 = [];
                    for (let i = day;i>=0;i--){
                        if (i===0){
                            texts.push('امروز');
                        }else if(i===1){
                            texts.push('دیروز');
                        }else {
                            texts.push(i+' روز پیش');
                        }
                        let v1 = parseInt(response.data['day'+i+'1']);
                        let v2 = parseInt(response.data['day'+i+'2']);
                        let v3 = parseInt(response.data['day'+i+'3']);
                        values1.push(v1);
                        values2.push(v2);
                        values3.push(v3);
                    }

                    this.setState({
                        allview1:parseInt(response.data['allview1']),
                        allview2:parseInt(response.data['allview2']),
                        allview3:parseInt(response.data['allview3']),
                    });


                    $('#canvasloading').addClass("novisible");
                    $('#myChart').removeClass("novisible");

                    if (this.myChart ===null) {

                        this.viewsChart.data.labels = texts;
                        this.viewsChart.data.datasets[0].data = values1;
                        this.viewsChart.options.animations = {

                        };
                        this.viewsChart.update();

                        let ctx = $('#myChart').get(0).getContext("2d");
                        this.myChart = new Chart(ctx, {
                            type: 'line',
                            data: {
                                labels: texts,
                                datasets: [{
                                    label: "کل بازدیدها",
                                    data: values1,
                                    backgroundColor: 'rgba(0,0,0,.4)',
                                    borderColor: '#555',
                                    borderWidth: 3,
                                    tension: 0.4,
                                    pointBackgroundColor: '#333'
                                }, {
                                    label: "بازدید واقعی",
                                    data: values2,
                                    backgroundColor: 'rgba(38,189,58,0.4)',
                                    borderColor: '#34b62f',
                                    borderWidth: 3,
                                    tension: 0.4,
                                    pointBackgroundColor: '#1f8721'
                                }, {
                                    label: "بازدید تکراری",
                                    data: values3,
                                    backgroundColor: 'rgba(38,98,189,0.4)',
                                    borderColor: '#2f70b6',
                                    borderWidth: 3,
                                    tension: 0.4,
                                    pointBackgroundColor: '#22638e'
                                }]
                            },

                            options: {
                                responsive: true,
                                maintainAspectRatio: false,
                                interaction: {
                                    mode: 'index',
                                    intersect: false,
                                    font: {
                                        size: 14,
                                        family: "'IRANSans',IRANSansWeb"
                                    }
                                },
                                // animations: {
                                //     tension: {
                                //         duration: 1000,
                                //         easing: 'linear',
                                //         from: 1,
                                //         to: 0,
                                //         loop: true
                                //     }
                                // },
                                scales: {
                                    x: {
                                        ticks: {
                                            // For a category axis, the val is the index so the lookup via getLabelForValue is needed
                                            callback: function (val, index) {
                                                // Hide the label of every 2nd dataset
                                                return index % 2 === 0 ? this.getLabelForValue(val) : this.getLabelForValue(val);
                                            },
                                            align: "start",
                                            color: 'black',
                                            font: {
                                                size: 14,
                                                family: "'IRANSans',IRANSansWeb"
                                            }
                                        }
                                    },
                                    y: {
                                        ticks: {
                                            min: 0,
                                            // For a category axis, the val is the index so the lookup via getLabelForValue is needed
                                            callback: function (val, index) {
                                                // Hide the label of every 2nd dataset
                                                return index % 2 === 0 ? this.getLabelForValue(val) : this.getLabelForValue(val);
                                            },
                                            color: 'black',
                                            font: {
                                                size: 14,
                                                family: "'IRANSans',IRANSansWeb"
                                            }
                                        }
                                    }

                                },
                                plugins: {
                                    legend: {

                                        labels: {
                                            // This more specific font property overrides the global property
                                            font: {
                                                size: 14,
                                                family: "'IRANSans',IRANSansWeb"
                                            }
                                        },
                                    },

                                }

                            }
                        });
                    }else {
                        this.myChart.data.labels = texts;
                        this.myChart.data.datasets[0].data = values1;
                        this.myChart.data.datasets[1].data = values2;
                        this.myChart.data.datasets[2].data = values3;
                        this.myChart.options.animations = {

                        };
                        this.myChart.options.plugins.title = {
                            display: false,
                            font: {
                                size: 14,
                                family: "'IRANSans',IRANSansWeb"
                            },
                            text:'در حال بارگذاری ...'
                        };
                        this.myChart.update();
                    }

                }
            })
            .catch(err=>{
                console.log(err);
            });

    }

    handletime(e){
        let day = this.state.day;
        let nday = e.currentTarget.id;
        let nnday = parseInt(e.currentTarget.id.replace('time',''));
        $('#time'+day).removeClass('active');
        $('#'+nday).addClass('active');
        //$('#myChart').addClass("novisible");
        //$('#canvasloading').removeClass("novisible");
        $('#dropdownMenuButton')[0].innerText = e.currentTarget.innerText;
        this.myChart.options.animations = {
            tension: {
                duration: 500,
                easing: 'linear',
                from: 0.4,
                to: 0.9,
                loop: true
            }
        };
        this.myChart.options.plugins.title = {
            display: true,
            font: {
                size: 14,
                family: "'IRANSans',IRANSansWeb"
            },
            text:'در حال بارگذاری ...'
        };
        this.myChart.update();
        this.loadChart(nnday);

    }

    render() {
        $('#progressTop').addClass('invisible');
        const {allpay,alluser,allview1,allview2,allview3} = this.state;

        console.log(this.props.auth);
        let percent2 = (allview2 * 100) / allview1;
        let percent3 = 100 - percent2;
        let p2 = parseFloat(percent2).toFixed(2);
        let p3 = parseFloat(percent3).toFixed(2);

        return (
            <div className="container-fluid">
            <SideBar li="mainpanel"/>
            <div className="col-12 bg-light p-4 homee">

                <div className="card-deck">
                    <div className="card text-white bg-primary text-right mb-3">
                        <div className="card-header">
                            <h5 className="text-white">{Intl.NumberFormat().format(allpay)+" تومان"}</h5>
                            <p className="card-text blockquote-footer text-white">درآمد کلی سایت</p>
                        </div>
                        <div className="card-body">
                            <canvas id="income" className="w-100" height="100%"></canvas>
                        </div>
                    </div>
                    <div className="card text-white bg-success text-right mb-3">
                        <div className="card-header">
                            <h5 className="text-white">{Intl.NumberFormat().format(alluser)+" کاربر"}</h5>
                            <p className="card-text blockquote-footer text-white">تعداد کلی کاربران سایت</p>
                        </div>
                        <div className="card-body">
                            <canvas id="users" className="w-100" height="100%"></canvas>
                        </div>
                    </div>
                    <div className="card text-white bg-warning text-right mb-3">
                        <div className="card-header">
                            <h5 className="text-white">{Intl.NumberFormat().format(allview1)+" بازدید"}</h5>
                            <p className="card-text blockquote-footer text-white">مقدار کلی بازدید سایت</p>
                        </div>
                        <div className="card-body">
                            <canvas id="views" className="w-100" height="100%"></canvas>
                        </div>
                    </div>

                </div>

                <div
                    className="d-flex justify-content-between align-items-center flex-md-nowrap border-bottom pb-2 my-3">
                    <h1 className="h2">آمار بازدید</h1>
                    <div className="dropdown">
                        <button className="btn btn-outline-secondary dropdown-toggle" type="button" id="dropdownMenuButton"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            این هفته
                        </button>
                        <div className="dropdown-menu text-right" aria-labelledby="dropdownMenuButton">
                            <a className="dropdown-item active" id={'time7'} onClick={this.handletime.bind(this)}>این هفته</a>
                            <a className="dropdown-item" id={'time30'} onClick={this.handletime.bind(this)}>این ماه</a>
                            <a className="dropdown-item" id={'time365'} onClick={this.handletime.bind(this)}>امسال</a>
                        </div>
                    </div>

                </div>

                <div className="card">

                    <div className="card-body">
                        <canvas id="myChart" className="w-100" height="400"/>
                        <div id="canvasloading" className="d-flex justify-content-cente">
                            <h4>درحال بارگذاری ...</h4>
                            <CircularProgress className="mr-3" color="secondary"/>
                        </div>
                    </div>
                    <div className="card-footer">
                        <h3 className="text-center">از ابتدا تا امروز</h3>
                        <div className="row mt-2">
                            <div className="text-center col-md-4">
                                <h5>همه بازدیدها</h5>
                                <p><strong>{allview1+' بازدید (100%)'}</strong></p>
                                <div className="progress">
                                    <div className="progress-bar bg-secondary" style={{width: '100%'}}></div>
                                </div>
                            </div>
                            <div className="text-center col-md-4">
                                <h5>بازدید واقعی</h5>
                                <p><strong>{allview2+' بازدید'+' ('+p2+'%)'}</strong></p>
                                <div className="progress">
                                    <div className="progress-bar bg-success" style={{width: p2+'%'}}></div>
                                </div>
                            </div>
                            <div className="text-center col-md-4">
                                <h5>بازدید تکراری</h5>
                                <p><strong>{allview3+' بازدید'+' ('+p3+'%)'}</strong></p>
                                <div className="progress">
                                    <div className="progress-bar bg-primary" style={{width: p3+'%'}}></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            </div>
        );
    }
}

export default Panel;
